// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__25Cuf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__Pbbbb"};